import axios from './api';

export default async function surveySubmit(params) {
    return await axios({
        headers: { 
            Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
        method: 'post',
        url: "/product/saveProductComment",
        params: {
            productId: params.productId,
            comment: params.comment,
        }
    })
    .then((res) => {
      if (res.status === 200) {
        return res.status;
      }
    })
    .catch((res) => {
      throw new Error(res.response.data.message);
    })
}